import { render, staticRenderFns } from "./BodyAnatomyTypeFloatBtns.vue?vue&type=template&id=1421b450&"
import script from "./BodyAnatomyTypeFloatBtns.vue?vue&type=script&lang=js&"
export * from "./BodyAnatomyTypeFloatBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports